module.exports = __webpack_public_path__ + "static/media/project-diagram.940bff5d.svg";